// extracted by mini-css-extract-plugin
export var animationContainer = "_nu-0";
export var footer = "_nu-1";
export var gray = "_nu-2";
export var lineItem = "_nu-3";
export var lineItemImage = "_nu-4";
export var lineItemInfo = "_nu-5";
export var lineItemText = "_nu-6";
export var lineItems = "_nu-7";
export var modalContent = "_nu-8";
export var options = "_nu-9";
export var orderName = "_nu-a";
export var refundAmount = "_nu-b";